/**
 * qiyu sdk utils
 */
import md5 from 'crypto-js/md5'
import QIYU_CONFIG from './config'

let YSF = null
let isInitialized = false
let initPromise = null

/**
 * dynamically load qiyu sdk
 */
export const loadQiyuSDK = async () => {
  if (YSF) return YSF

  try {
    const qiyuModule = await import('@neysf/qiyu-web-sdk')
    YSF = qiyuModule.default
    return YSF
  } catch (error) {
    console.error('qiyu sdk load failed:', error)
    throw new Error('qiyu sdk load failed')
  }
}

/**
 * get language config
 */
export const getLanguageConfig = (language, latestRobot) => {
  if (latestRobot) {
    return latestRobot === QIYU_CONFIG.ROBOT_CONFIG.hk.robotId ? 'hk' : 'en'
  }
  return ['zhHK', 'zh'].includes(language) ? 'hk' : 'en'
}

/**
 * generate auth token
 */
export const generateAuthToken = (accountCard) => md5(`${accountCard}${QIYU_CONFIG.AUTH.secret}`).toString()

/**
 * build qiyu config
 */
export const buildQiyuConfig = (userData, parentInfo = {}) => {
  const {
    language, accountCard, schoolTag, referrer, title, latestRobot,
  } = userData
  const langKey = getLanguageConfig(language, latestRobot)
  const robotConfig = QIYU_CONFIG.ROBOT_CONFIG[langKey]

  const config = {
    uid: accountCard.toString(),
    isShowBack: 0,
    robotShuntSwitch: 0,
    // robotId: robotConfig.robotId,
    templateId: robotConfig.templateId,
    language: 'en', // robotConfig.language,
    tags: schoolTag.toUpperCase(),
    authToken: generateAuthToken(accountCard),
    // groupid: `482448381`, // `482395643`, // groupid is the id of the group to which the user belongs
    shuntId: robotConfig.shuntId, // shuntId is the id of the shunt to which the user belongs
  }

  // add optional fields (qiyu limit empty string)
  const { nickName, email, phone } = parentInfo
  if (nickName) config.name = nickName
  if (email) config.email = email
  if (phone) config.phone = phone
  if (referrer) config.referrer = referrer
  if (title) config.title = title

  return config
}

/**
 * initialize qiyu sdk
 */
export const initQiyuSDK = async (config) => {
  const ysf = await YSF.init(QIYU_CONFIG.APP_KEY, config, QIYU_CONFIG.ENVIRONMENT)
  return ysf
}

/**
 * initialize qiyu customer service
 */
export const initQiyuCustomerService = async (userData, parentInfo = {}) => {
  if (isInitialized) {
    console.log('qiyu sdk already initialized, skip')
    return Promise.resolve()
  }

  if (initPromise) {
    return initPromise
  }

  initPromise = (async () => {
    try {
      // 1. load qiyu sdk
      await loadQiyuSDK()

      // 2. build qiyu config
      const config = buildQiyuConfig(userData, parentInfo)

      // 3. initialize qiyu sdk
      const ysf = await initQiyuSDK(config)

      // 4. configure qiyu
      ysf('config', {
        ...config,
        success: () => {
          console.log('qiyu sdk config success')
          // ysf('open')
          isInitialized = true
        },
        error: (error) => {
          console.error('qiyu sdk config failed:', error)
          throw error
        },
      })

      return Promise.resolve()
    } catch (error) {
      console.error('qiyu sdk init failed:', error)
      //
      throw error
    }
  })()

  return initPromise
}

/**
 * reset initialization state (for testing or reinitialization)
 */
export const resetQiyuInitialization = () => {
  isInitialized = false
  initPromise = null
}
